"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.minutesBetween = exports.hoursBetween = exports.timeBetween = exports.durationBetween = void 0;
const moment_1 = __importDefault(require("moment"));
require("moment-duration-format");
const durationBetween = function (target) {
  let reference = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, moment_1.default)();
  let unit = arguments.length > 2 ? arguments[2] : undefined;
  return moment_1.default.duration(target.diff(reference), unit);
};
exports.durationBetween = durationBetween;
const timeBetween = (target, reference, unit, format) => (0, exports.durationBetween)(target, reference, unit).format(format);
exports.timeBetween = timeBetween;
const hoursBetween = (target, reference) => (0, exports.timeBetween)(target, reference, "h", "h[h]mm[m]");
exports.hoursBetween = hoursBetween;
const minutesBetween = (target, reference) => (0, exports.timeBetween)(target, reference, "m", "mm[m]");
exports.minutesBetween = minutesBetween;